export var getState = function getState() {
    return sessionStorage.getItem('state');
};
export var setState = function setState(state) {
    return sessionStorage.setItem('state', state);
};

export var getPreviousPath = function getPreviousPath() {
    return sessionStorage.getItem('previousPath');
};
export var setPreviousPath = function setPreviousPath(previousPath) {
    return sessionStorage.setItem('previousPath', previousPath);
};

export var getRedirectUri = function getRedirectUri() {
    var url = window.location.protocol + '//' + window.location.hostname;

    if (window.location.port) {
        url = url + ':' + window.location.port;
    }

    return url + '/oauth2/callback';
};

export var cleanStorage = function cleanStorage() {
    sessionStorage.removeItem('state');
    sessionStorage.removeItem('previousPath');
};